<template>
  <div>
    <PageAllow controller="Purchases" action="getNegotiatePriceDetails" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5 my-5">
          <v-col cols="12" sm="12" md="12" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                small
                color="success"
                :dark="Details.length != 0"
                class="ms-1"
                @click.stop="save()"
                :disabled="Details.length == 0"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("financeBillBatchEdit.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="Details"
            :loading="loading"
            :page.sync="paging.page"
            :options.sync="options"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.prices="{ item }">
              <v-text-field
                v-model="item.prices"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.prices = $numberFormatter.formatWithDotNoMoreThan(
                    item.prices,
                    2
                  )
                "
              />
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Purchases from "@/api/purchases";
const defaultOptions = {};
export default {
  data: () => ({
    paging: {},
    Details: [],
    ary: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
  }),
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("Nav.purchasesList"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("PurchasesList.Fields.NegotiatePrices"),
        disabled: true,
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("PurchasesList.batchNegotiate.purchase_code"),
          align: "start",
          sortable: false,
          value: "purchase_code",
        },
        {
          text: i18n.t("PurchasesList.batchNegotiate.material_category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("PurchasesList.batchNegotiate.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesList.batchNegotiate.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesList.batchNegotiate.prices"),
          align: "end",
          sortable: false,
          value: "prices",
          width: "120px",
        },
      ];
    },

    ...mapState(["loading"]),
  },

  methods: {
    onSearch() {
      this.getNegotiatePriceDetails();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    // 获取商品列表
    getNegotiatePriceDetails() {
      Purchases.getNegotiatePriceDetails(
        Object.assign(this.options, {
          purchase_ids: this.$route.query.purchase_ids,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.Details = response.data.purchase_details;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },

    save() {
      let data = [];
      data = this.Details.map((detail) => {
        return {
          purchase_id: detail.purchase_id,
          purchase_detail_id: detail.purchase_detail_id,
          prices: detail.prices,
        };
      });
      Purchases.negotiatePriceBatchSave(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/purchases");
          }
        }.bind(this)
      );
    },
  },

  mounted() {
    this.getNegotiatePriceDetails();
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getNegotiatePriceDetails();
      },
    },
  },
};
</script>

<style>
</style>